/* eslint-disable */
import { CategoryService } from '@/store/category/category-service'
import Message from '@/shared/message/toastify'
import Errors from '@/shared/error/errors'
import { i18n } from '@/locales/i18n'

export default {
  namespaced: true,
  state: {
    loading: false
  },
  getters: {
    loading: state => !!state.loading
  },
  mutations: {
    DESTROY_STARTED(state) {
      state.loading = true
    },
    DESTROY_SUCCESS(state) {
      state.loading = false
    },
    DESTROY_ERROR(state) {
      state.loading = false
    }
  },
  actions: {
    async doDestroy({ commit, dispatch }, id) {
      try {
        commit('DESTROY_STARTED')
        await CategoryService.removeCategory(id)
        commit('DESTROY_SUCCESS')
        Message.success(i18n('category.destroy.success'))
        dispatch(`category/list/listAllCategories`, null, { root: true })
      } catch (error) {
        Errors.handle(error)
        commit('DESTROY_ERROR')
      }
    }
  }
}
